/**
  * vue-cal v3.11.0
  * (c) 2022 Antoni Andre <antoniandre.web@gmail.com>
  * @license MIT
  */
const a = ["M\xE5ndag", "Tisdag", "Onsdag", "Torsdag", "Fredag", "L\xF6rdag", "S\xF6ndag"], e = ["Januari", "Februari", "Mars", "April", "Maj", "Juni", "Juli", "Augusti", "September", "Oktober", "November", "December"], d = "\xC5r", n = "\xC5r", s = "M\xE5nad", t = "Vecka", r = "Dag", o = "Idag", g = "Ingen h\xE4ndelse", l = "Heldag", M = "Ta bort", y = "Skapa h\xE4ndelse", k = "dddd den D MMMM YYYY", m = { weekDays: a, months: e, years: "\xC5r", year: "\xC5r", month: "M\xE5nad", week: "Vecka", day: "Dag", today: "Idag", noEvent: "Ingen h\xE4ndelse", allDay: "Heldag", deleteEvent: "Ta bort", createEvent: "Skapa h\xE4ndelse", dateFormat: "dddd den D MMMM YYYY" };
export {
  l as allDay,
  y as createEvent,
  k as dateFormat,
  r as day,
  m as default,
  M as deleteEvent,
  s as month,
  e as months,
  g as noEvent,
  o as today,
  t as week,
  a as weekDays,
  n as year,
  d as years
};
